
import { Component } from 'nuxt-property-decorator'
import { alertStore, modalReturnCheckAlertStore } from '@/store'
import { Col } from '@/components/molecules/DataTable'
import { defaultReturnCheckAlert, ReturnCheckAlert } from '@/api'
import { ModalAlert } from '@/components/modals/ModalAlert'
import { AlertCodeBAT00015 } from '@/types'
import { ModalAlertAddButton } from '@/store/ModalAlertStore'
import { AlertFactory } from '@/factory'

@Component({
  components: {}
})
export default class ModalReturnCheckAlert extends ModalAlert {
  get isOpen(): boolean {
    return modalReturnCheckAlertStore.isOpen
  }

  get modalType(): string {
    if (modalReturnCheckAlertStore.modalType)
      return modalReturnCheckAlertStore.modalType
    if (this.items.length) return this.items[0].level
    return ''
  }

  get isUseOk(): boolean {
    return modalReturnCheckAlertStore.isUseOk
  }

  get addButtons(): ModalAlertAddButton[] {
    return modalReturnCheckAlertStore.addButtons
  }

  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '20',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'code',
            headerText: 'コード'
          }
        ]
      },
      {
        width: '80',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'message',
            headerText: 'メッセージ',
            lineFeed: true
          }
        ]
      },
      {
        width: 30,
        items: [
          {
            name: 'remove',
            align: 'center'
          }
        ]
      }
    ]
  }

  get items(): ReturnCheckAlert[] {
    if (alertStore.returnCheckItems.length > 0) {
      return alertStore.returnCheckItems.filter(
        (value: ReturnCheckAlert, index: number, items: ReturnCheckAlert[]) => {
          return (
            items.findIndex(
              item => item.code === value.code && item.message === value.message
            ) === index
          )
        }
      )
    }

    return [
      Object.assign(
        defaultReturnCheckAlert(),
        AlertFactory.create('ALC00012', '返却')
      )
    ]
  }

  displayRemoveButton(index: number): boolean {
    return this.items[index].userMemoId !== 0
  }

  onClickOk(): void {
    modalReturnCheckAlertStore.ok()

    const sessionTimeOutItem = this.items.find(
      item => item.code === AlertCodeBAT00015
    )
    if (sessionTimeOutItem) {
      location.href = '/login'
    }
  }

  onClickCancel(): void {
    modalReturnCheckAlertStore.cancel()
  }

  onClickRemove(index: number): void {
    modalReturnCheckAlertStore.remove(index)
  }
}
